import { isDevelopment, isEnv } from '../index';
import { TenantsConfig } from '../../store/features/pageConfig';

export type GenerateDomainUrlProps = {
  domains: TenantsConfig;
  tenant: string;
  path: string;
};

export function generateDomainUrl(props: GenerateDomainUrlProps): string {
  const { domains, tenant, path } = props;
  const host = domains[tenant].domain;
  const env = isEnv();
  const port = isDevelopment() ? ':3000' : '';
  const prefix = env === 'prod' ? '' : `${env}.`;

  return `https://${prefix}${host}${port}/${path}/`;
}
